module.exports = fox._r("images/slideshow_stop.png", __webpack_public_path__ + "images/slideshow_stop.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/slideshow_stop.png
// module id = 1118
// module chunks = 4